import { Injectable } from '@angular/core';
import { Router, UrlTree, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const currentPath = this.router.url;

    // Public routes that don't require authentication
    const publicRoutes = [
      '/auth/login',
      '/auth/register',
      '/auth/forgot-password',
      '/auth/reset-password',
      '/auth/verify',
      '/auth/facebook-callback'
    ];

    // Check if current route is public
    const isPublicRoute = publicRoutes.some(route => currentPath.startsWith(route));
    
    if (isPublicRoute) {
      return true;
    }

    // Check if user is authenticated (has token)
    const isAuthenticated = this.authService.isAuthenticated();
    
    if (!isAuthenticated) {
      return this.router.createUrlTree(['/auth/login']);
    }

    return true;
  }
}
